// extracted by mini-css-extract-plugin
export default {"daoPercentages":"DaoPercentagesListing_daoPercentages__4QzUt"};